(() => {
  const calendar = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'});
  const display = new Intl.DateTimeFormat('en-GB', {timeZone:'UTC',weekday:'short',day:'numeric',month:'short'});
  const iso = date => date.toISOString().slice(0,10);
  const getDispatchDate = (now = new Date()) => {
    const parts=Object.fromEntries(calendar.formatToParts(now).map(part=>[part.type,part.value]));
    const date=new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day)+1));
    return date;
  };
  const update = () => {
    const date=getDispatchDate();
    document.querySelectorAll('[data-amp-dispatch-date]').forEach(element=>{
      element.setAttribute('datetime',iso(date));
      element.textContent=display.format(date);
    });
  };
  update();
  window.addEventListener('pageshow',update);
  document.addEventListener('shopify:section:load',update);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden) update();});
  window.setInterval(()=>{if(!document.hidden) update();},60000);
})();
